import { gql } from '@apollo/client';

export const GET_MULTI_LANGUAGE_FEATURE = gql`
  query getMultiLanguageFeature {
    multiLanugageFeature {
      data {
        attributes {
          section_one {
            title
            content
          }
          section_two {
            title
            content
          }
          section_three {            
            title
            content
          }
        }
      }
    }
  }
`;
